import React from 'react';
import Button from 'atomic/button';
import classNames from 'classnames';

import './price-history-chart-ranges.scss';

const RANGE_LIST: { value: number; label: string; shortLabel: string; }[] = [
    { value: 14, label: '14 dni', shortLabel: '14d' },
    { value: 90, label: '3 miesiące', shortLabel: '3m' },
    { value: 182, label: '6 miesięcy', shortLabel: '6m' },
    { value: 365, label: '1 rok', shortLabel: '1r' }
];

interface PriceHistoryChartRanges {
    setRange: (range: number) => void;
    range: number;
    margin?: 'sm' | 'md' | 'lg';
    shortList?: boolean;
}

const PriceHistoryChartRanges: React.FC<PriceHistoryChartRanges> = ({ range, setRange, margin = '', shortList = false }) => (
    <div className="price-history-range-list">
        {
            RANGE_LIST.map(priceHistoryRange => (
                <Button
                    key={priceHistoryRange.value}
                    noWrap={true}
                    border={false}
                    onClick={(): void => setRange(priceHistoryRange.value)}
                    className={classNames({
                        'price-history-range-list__item': true,
                        [`price-history-range-list__item--${margin}`]: margin !== '',
                        [`gtm_ua_ph_${priceHistoryRange.value}d`]: true,
                        'price-history-range-list__item--active': range === priceHistoryRange.value
                    })}
                >
                    { shortList ? priceHistoryRange.shortLabel : priceHistoryRange.label }
                </Button>
            ))
        }
    </div>
);

export default PriceHistoryChartRanges;
